// Shared currency formatting helper. Reads the per-account `currency_symbol`
// (see backend routes/settings_routes.py GET/PUT /settings/system) instead of
// hardcoding "$" — existing US accounts keep rendering with "$" since that's
// the default here and the DB column's default.
export const DEFAULT_CURRENCY_SYMBOL = "$";

/**
 * Format a numeric value as currency: "$1,234.56".
 * @param {number} value
 * @param {string} [currencySymbol] defaults to "$"
 * @param {number} [decimals] defaults to 2
 */
export function formatCurrency(value, currencySymbol = DEFAULT_CURRENCY_SYMBOL, decimals = 2) {
  const num = Number(value) || 0;
  const formatted = num.toLocaleString("en-US", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
  return `${currencySymbol}${formatted}`;
}

/**
 * Format a signed P&L value as currency, keeping the sign explicit:
 * "+$1,234.56" / "-$1,234.56".
 */
export function formatCurrencySigned(value, currencySymbol = DEFAULT_CURRENCY_SYMBOL, decimals = 2) {
  const num = Number(value) || 0;
  const sign = num > 0 ? "+" : num < 0 ? "-" : "";
  return `${sign}${formatCurrency(Math.abs(num), currencySymbol, decimals)}`;
}
